import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import PageWrapper from '../components/PageWrapper';
import SEO from '../components/SEO';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { mockProfiles } from '../data/mockData';

const BewerberProfil = () => {
  const { id } = useParams();
  const profile = mockProfiles.find(p => p.id === id) || mockProfiles[0];
  const currentUrl = window.location.href;

  return (
    <PageWrapper className="bg-slate-50 py-12">
      {/* NOINDEX für Datenschutz: Bewerberprofile werden nicht gegoogelt */}
      <SEO 
        title={`Profil ${profile.id} - ${profile.profession}`} 
        description="Vertrauliches Bewerberprofil bei Nordblick Recruiting." 
        noindex={true} 
      />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-amber-50 border border-amber-200 text-amber-800 px-4 py-3 rounded-lg mb-6 flex items-start gap-3 text-sm shadow-sm">
          <SafeIcon icon={FiIcons.FiLock} className="h-5 w-5 shrink-0 mt-0.5" />
          <div>
            <strong>Vertrauliches Profil:</strong> Dieses Profil ist nicht öffentlich suchbar und wird von Suchmaschinen blockiert. Der Zugriff ist nur über diesen direkten Link oder den QR-Code möglich.
          </div>
        </div>
        {/* Rest des Profils... */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden text-slate-800">
           <div className="p-8 md:p-12 border-b border-slate-100 flex flex-col md:flex-row justify-between items-start gap-6">
            <div>
              <div className="text-sm font-bold text-slate-400 mb-2">Bewerber-ID: {profile.id}</div>
              <h1 className="text-3xl font-bold text-blue-900 mb-2">{profile.profession}</h1>
              <p className="text-cyan-600 font-medium">{profile.industry}</p>
            </div>
            <div className="bg-slate-50 p-3 rounded-xl shadow-sm shrink-0 border border-slate-100 text-center">
              <QRCodeSVG value={currentUrl} size={100} />
              <p className="text-[10px] text-slate-500 mt-2 font-medium">Profil-QR</p>
            </div>
          </div>
          <div className="p-8 md:p-12">
            {/* Profildetails... */}
            <div className="border-t border-slate-200 pt-8 text-center">
              <h3 className="text-lg font-bold text-blue-900 mb-4">Interesse an diesem Bewerber?</h3>
              <Link to="/unternehmen" className="inline-block bg-cyan-600 text-white font-bold py-3 px-8 rounded-md hover:bg-cyan-500 transition-colors shadow-md">
                Bewerber anfragen (Ref: {profile.id})
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default BewerberProfil;